import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setContentHeight } from './actions'

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ setContentHeight }, dispatch)
}

export default (InnerComponent) => {
    @connect(null, mapDispatchToProps)
    class hocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocConnect
}
